import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startReport206202VerprobungStatus: 'idle',
    startReport206202VerprobungError: undefined as any,
    loadUserParamsReport206202VerprobungStatus: 'idle',
    loadUserParamsReport206202VerprobungError: undefined as any,

    report206202VerprobungList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startReport206202Verprobung = createAsyncThunk('report206202VerprobungSlice/startReport206202Verprobung', async ({ report206202Verprobung }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartReport206202Verprobung/`,
        prepareData(report206202Verprobung),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startReport206202VerprobungStatus } = getState().report206202VerprobungSlice
        return startReport206202VerprobungStatus !== 'pending'
    }
})

export const loadUserParamsReport206202Verprobung = createAsyncThunk('report206202VerprobungSlice/loadUserParamsReport206202Verprobung', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsReport206202Verprobung/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsReport206202VerprobungStatus } = getState().report206202VerprobungSlice
        return loadUserParamsReport206202VerprobungStatus !== 'pending'
    }
})

const Report206202VerprobungSlice = createSlice({
    name: 'report206202VerprobungSlice',
    initialState,
    reducers: {
        resetstartReport206202Verprobung: (state) => {
            state.job = undefined
            state.startReport206202VerprobungError = undefined
        },
        resetstartReport206202VerprobungError: (state) => {
            state.startReport206202VerprobungError = undefined
        },
        resetloadUserParamsReport206202Verprobung: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsReport206202VerprobungError = undefined
        },
        resetloadUserParamsReport206202VerprobungError: (state) => {
            state.loadUserParamsReport206202VerprobungError = undefined
        },
        removeFromReport206202VerprobungListById: (state, action) => {
            state.report206202VerprobungList = state.report206202VerprobungList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromReport206202VerprobungListByIds: (state, action) => {
            state.report206202VerprobungList = state.report206202VerprobungList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.report206202VerprobungList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startReport206202VerprobungStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.report206202VerprobungList = []
            state.startReport206202VerprobungStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startReport206202Verprobung.pending, (state) => {
            state.startReport206202VerprobungStatus = 'pending'
            state.startReport206202VerprobungError = undefined
        })
        builder.addCase(startReport206202Verprobung.fulfilled, (state, action) => {
            state.startReport206202VerprobungStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startReport206202Verprobung.rejected, (state, action) => {
            state.startReport206202VerprobungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startReport206202VerprobungError = action.error.message
            } else {
                state.startReport206202VerprobungError = action.payload
            }
        })

        builder.addCase(loadUserParamsReport206202Verprobung.pending, (state) => {
            state.loadUserParamsReport206202VerprobungStatus = 'pending'
            state.loadUserParamsReport206202VerprobungError = undefined
        })
        builder.addCase(loadUserParamsReport206202Verprobung.fulfilled, (state, action) => {
            state.loadUserParamsReport206202VerprobungStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsReport206202Verprobung.rejected, (state, action) => {
            state.loadUserParamsReport206202VerprobungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsReport206202VerprobungError = action.error.message
            } else {
                state.loadUserParamsReport206202VerprobungError = action.payload
            }
        })

    }
})

export const {
    resetstartReport206202Verprobung,
    resetstartReport206202VerprobungError,
    resetloadUserParamsReport206202Verprobung,
    resetloadUserParamsReport206202VerprobungError,
    removeFromReport206202VerprobungListById,
    removeFromReport206202VerprobungListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Report206202VerprobungSlice.actions
export default Report206202VerprobungSlice.reducer
